module.exports = __webpack_public_path__ + "static/media/graphcms-logo.ab5d7cb9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/graphcms-logo.svg
// module id = 244
// module chunks = 0